/**
 * Normalize markdown so remark-gfm reliably parses tables.
 *
 * GFM requires a blank line before the first pipe row for the table to be
 * recognized. LLMs often omit this blank line, producing output like:
 *
 *   Here are your users:
 *   | Email | Name |
 *   |-------|------|
 *
 * This function inserts a blank line before any table block that doesn't
 * already have one, so react-markdown renders a proper <table>.
 */
export function normalizeMarkdownTables(content: string): string {
  const lines = content.split('\n');
  const result: string[] = [];

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i]!;
    const trimmed = line.trimStart();
    const isTableRow = trimmed.startsWith('|');
    const prev = result[result.length - 1];
    const prevIsBlankOrUndefined = prev === undefined || prev.trim() === '';
    const prevIsTableRow = prev !== undefined && prev.trimStart().startsWith('|');

    // Insert blank line before the first row of a table block
    if (isTableRow && !prevIsBlankOrUndefined && !prevIsTableRow) {
      result.push('');
    }

    result.push(line);
  }

  return result.join('\n');
}
